<div id="noticia" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent p-24" ffxLayout="row" fxLayoutAlign="start center">
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/central-noticias'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div 
                    class="user-image mr-8 mr-sm-16" 
                    [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}"
                >
                    <img 
                        [src]="noticia.user.url_avatar" 
                        style="border-radius: 60px;"
                        height="96"
                        width="96"
                    />
                </div>

                <div 
                    fxLayout="column" 
                    fxLayoutAlign="start start"
                    [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}"
                >
                    <div class="h2">
                        {{noticia.titulo}}
                    </div>
                    <div class="subtitle secondary-text">
                        <span>{{noticia.categoria.nome}}</span>
                    </div>
                    <div class="subtitle secondary-text">
                        <span>por </span>
                        <span>{{noticia.user.name}}</span>
                    </div>
                    <div class="subtitle secondary-text">
                        <span>em </span>
                        <span>{{noticia.created_at | date:'dd/MM/yyyy'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div class="content-card">
            <div id="noticia-content" class="content m-8 p-16">
                <div class="noticia-texto">
                    <div  fxLayout="column" class="article">
                        <div *ngIf="loadingIndicator == false && noticia.midia" class="media">
                            <app-secured-image 
                                [src]="getUrlMidia()" 
                                [alt]="noticia.titulo">
                            </app-secured-image>
                        </div>
                        <div 
                            *ngIf="noticia?.texto" 
                            class="message mb-16" 
                            [innerHTML]="noticia.texto">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CENTER -->

</div>